import React, {Component} from 'react';
export default class UserMenu extends Component {

    render(){
        return  <ul id="sidebarnav">
                        <li>
                            <a className="has-arrow " href="/schedule" aria-expanded="false"><i className="ti-calendar"></i><span className="hide-menu">Scheduler</span></a>
                            
                         </li>                      
                   
                    </ul>;
    }

}